import useUrlState from "./useUrlState";

export interface SetValue {
  (value: number): void;
}

export default function useUrlStateNumber(
  key: string,
  defaultValue?: number,
  replace?: boolean
): [number | undefined, SetValue] {
  const [stringValue, setStringValue] = useUrlState(
    key,
    defaultValue !== undefined ? String(defaultValue) : undefined,
    replace
  );

  const setValue = (value: number) => {
    setStringValue(String(value));
  };

  const value =
    stringValue !== undefined && !isNaN(Number(stringValue)) ? Number(stringValue) : undefined;

  return [value, setValue];
}
